import type { Step } from "react-joyride";

export const optionsListTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຈັດການ Product Options ທັງໝົດ. ຄົ້ນຫາ, ສ້າງໃໝ່, ແກ້ໄຂ ແລະລຶບ options.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="catalog-options-search"]',
    content: "ຄົ້ນຫາ options ດ້ວຍຊື່ ຫຼື slug.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="catalog-options-create-btn"]',
    content: "ກົດເພື່ອສ້າງ Product Option ໃໝ່.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="catalog-options-table"]',
    content:
      "ຕາຕະລາງສະແດງ options ທັງໝົດ ຊື່, slug, ຈຳນວນ values ແລະລຳດັບການສະແດງ.",
    placement: "top",
  },
  {
    target: '[data-tourid="catalog-options-actions"]',
    content: "ແກ້ໄຂ ຫຼື ລຶບ option ແຕ່ລະຕົວ.",
    placement: "left",
  },
];
